import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalComponent } from "./components/modal/modal.component";
import { RouterModule } from "@angular/router";
import { CoreModule } from "../core/core.module";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
	declarations: [ModalComponent, ConfirmDialogComponent],
	exports: [ModalComponent],
	imports: [CommonModule, RouterModule, CoreModule, MatDialogModule]
})
export class ModalModule {}
